import DevicesScreen from "./DevicesScreen";
export default DevicesScreen;
